import { FC, ReactNode } from 'react'

import { styled } from 'styled-components'

import { onSurface, onSurfaceVariant, outline, surface } from 'core/styles'

export type FieldGroupProps = {
  title: string
  children: ReactNode
  className?: string
  nestLevel?: number
}

const FieldGroup: FC<FieldGroupProps> = ({ title, children, className, nestLevel = 0 }) => (
  <Container className={className}>
    <Title>{title}</Title>
    <FieldsContainer $nestLevel={nestLevel}>{children}</FieldsContainer>
  </Container>
)

export default FieldGroup

const Container = styled.div`
  color: ${onSurface};
  font-size: 18px;
  font-weight: 600;
`

const Title = styled.h3`
  margin: 0 0 4px;
  color: ${onSurfaceVariant};
  font-size: 13px;
  font-weight: 500;
`

const FieldsContainer = styled.div<{ $nestLevel?: number }>`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${outline};
  border-radius: 8px;
  isolation: isolate;
  background: ${({ $nestLevel }) => (($nestLevel ?? 0) === 0 ? '#ffffff' : surface)};
  padding: 16px;

  &::before {
    position: absolute;
    inset: 0;
    opacity: ${({ $nestLevel }) => {
      const level = $nestLevel ?? 0
      // Start darkening from level 1 (level 0 is white, level 1+ gets darker)
      // Level 1 should be lighter gray, then progressively darker
      return level > 0 ? Math.min(0.02 * (level - 1) + 0.02, 0.2) : 0
    }};
    z-index: 0;
    border-radius: inherit;
    background: #000;
    content: '';
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`
